// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*  imported from Typography.module.scss  */
.Typography-module-Root_2Xd {
  /* убираем дэфолтные браузерные отступы */
  margin-top: 0;
  margin-bottom: 0;
  font-family: var(--typography-font-family);
  font-size: var(--typography-p1-font-size);
  font-weight: var(--typography-p-font-weight-default);
  font-style: normal;
  line-height: var(--typography-p1-line-height);
  letter-spacing: 0;
  color: var(--color-base); }

/* Variants */
.Typography-module-p1Variant_1ft {
  font-size: var(--typography-p1-font-size);
  line-height: var(--typography-p1-line-height); }

.Typography-module-p2Variant_lwF {
  font-size: var(--typography-p2-font-size);
  line-height: var(--typography-p2-line-height); }

.Typography-module-p3Variant_1yM {
  font-size: var(--typography-p3-font-size);
  line-height: var(--typography-p3-line-height); }

.Typography-module-p4Variant_1rq {
  font-size: var(--typography-p4-font-size);
  line-height: var(--typography-p4-line-height); }

/* Weight */
.Typography-module-defaultWeight_Ndf {
  font-weight: var(--typography-p-font-weight-default); }

.Typography-module-strongWeight_3VQ {
  font-weight: var(--typography-p-font-weight-strong); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Typography/Typography.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,2CAA2C;AAC3C;EACE,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,yCAAyC;EACzC,oDAAoD;EACpD,kBAAkB;EAClB,6CAA6C;EAC7C,iBAAiB;EACjB,wBAAwB,EAAE;;AAE5B,aAAa;AACb;EACE,yCAAyC;EACzC,6CAA6C,EAAE;;AAEjD;EACE,yCAAyC;EACzC,6CAA6C,EAAE;;AAEjD;EACE,yCAAyC;EACzC,6CAA6C,EAAE;;AAEjD;EACE,yCAAyC;EACzC,6CAA6C,EAAE;;AAEjD,WAAW;AACX;EACE,oDAAoD,EAAE;;AAExD;EACE,mDAAmD,EAAE","sourcesContent":["@charset \"UTF-8\";\n/*  imported from Typography.module.scss  */\n.Typography-module-Root_2Xd {\n  /* убираем дэфолтные браузерные отступы */\n  margin-top: 0;\n  margin-bottom: 0;\n  font-family: var(--typography-font-family);\n  font-size: var(--typography-p1-font-size);\n  font-weight: var(--typography-p-font-weight-default);\n  font-style: normal;\n  line-height: var(--typography-p1-line-height);\n  letter-spacing: 0;\n  color: var(--color-base); }\n\n/* Variants */\n.Typography-module-p1Variant_1ft {\n  font-size: var(--typography-p1-font-size);\n  line-height: var(--typography-p1-line-height); }\n\n.Typography-module-p2Variant_lwF {\n  font-size: var(--typography-p2-font-size);\n  line-height: var(--typography-p2-line-height); }\n\n.Typography-module-p3Variant_1yM {\n  font-size: var(--typography-p3-font-size);\n  line-height: var(--typography-p3-line-height); }\n\n.Typography-module-p4Variant_1rq {\n  font-size: var(--typography-p4-font-size);\n  line-height: var(--typography-p4-line-height); }\n\n/* Weight */\n.Typography-module-defaultWeight_Ndf {\n  font-weight: var(--typography-p-font-weight-default); }\n\n.Typography-module-strongWeight_3VQ {\n  font-weight: var(--typography-p-font-weight-strong); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
